// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ICourtDispositionCodeType {
    id: number;
    dispositionCodeType: any;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class CourtDispositionCodeType implements ICourtDispositionCodeType, IBaseType {
    public id: number;
    public dispositionCodeType: any;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns 10 - Guilty CourtDispositionCodeType
	**/
    get Ten(): ICourtDispositionCodeType {
        return this.FromId(1);
    }
    /**
		Returns 11 - Guilty CourtDispositionCodeType
	**/
    get Eleven(): ICourtDispositionCodeType {
        return this.FromId(2);
    }
    /**
		Returns 12 - Guilty CourtDispositionCodeType
	**/
    get Twelve(): ICourtDispositionCodeType {
        return this.FromId(3);
    }
    /**
		Returns 20 - Guilty CourtDispositionCodeType
	**/
    get Twenty(): ICourtDispositionCodeType {
        return this.FromId(4);
    }
    /**
		Returns 21 - Guilty CourtDispositionCodeType
	**/
    get TwentyOne(): ICourtDispositionCodeType {
        return this.FromId(5);
    }
    /**
		Returns 22 - Guilty CourtDispositionCodeType
	**/
    get TwentyTwo(): ICourtDispositionCodeType {
        return this.FromId(6);
    }
    /**
		Returns 30 - Dismissal CourtDispositionCodeType
	**/
    get Thirty(): ICourtDispositionCodeType {
        return this.FromId(7);
    }
    /**
		Returns 43 - Dismissal CourtDispositionCodeType
	**/
    get FortyThree(): ICourtDispositionCodeType {
        return this.FromId(8);
    }
    /**
		Returns 44 - Dismissal CourtDispositionCodeType
	**/
    get FortyFour(): ICourtDispositionCodeType {
        return this.FromId(9);
    }
    /**
		Returns 45 - Dismissal CourtDispositionCodeType
	**/
    get FortyFive(): ICourtDispositionCodeType {
        return this.FromId(10);
    }
    /**
		Returns 54 - Failure to comply CourtDispositionCodeType
	**/
    get FiftyFour(): ICourtDispositionCodeType {
        return this.FromId(11);
    }
    /**
		Returns 55 - Failure to pay on civil offense CourtDispositionCodeType
	**/
    get FiftyFive(): ICourtDispositionCodeType {
        return this.FromId(12);
    }
    /**
		Returns 56 - Failure to appear on criminal offense CourtDispositionCodeType
	**/
    get FiftySix(): ICourtDispositionCodeType {
        return this.FromId(13);
    }
    /**
		Returns 57 - Failure to appear on criminal offense CourtDispositionCodeType
	**/
    get FiftySeven(): ICourtDispositionCodeType {
        return this.FromId(14);
    }
    /**
		Returns 58 - Failure to appear on civil offense CourtDispositionCodeType
	**/
    get FiftyEight(): ICourtDispositionCodeType {
        return this.FromId(15);
    }
    /**
		Returns 59 - Stay CourtDispositionCodeType
	**/
    get FiftyNine(): ICourtDispositionCodeType {
        return this.FromId(16);
    }
    /**
		Returns 60 - Criminal Failure to Appear satisfied CourtDispositionCodeType
	**/
    get Sixty(): ICourtDispositionCodeType {
        return this.FromId(17);
    }
    /**
		Returns 67 - Amended CourtDispositionCodeType
	**/
    get SixtySeven(): ICourtDispositionCodeType {
        return this.FromId(18);
    }
    /**
		Returns 70 - Appeal - hearing CourtDispositionCodeType
	**/
    get Seventy(): ICourtDispositionCodeType {
        return this.FromId(19);
    }
    /**
		Returns 71 - Purge record CourtDispositionCodeType
	**/
    get SeventyOne(): ICourtDispositionCodeType {
        return this.FromId(20);
    }
    /**
		Returns 76 - Set-aside pursuant to ARS 13-907 CourtDispositionCodeType
	**/
    get SeventySix(): ICourtDispositionCodeType {
        return this.FromId(21);
    }
    /**
		Returns 00 - Void CourtDispositionCodeType
	**/
    get DoubleZero(): ICourtDispositionCodeType {
        return this.FromId(22);
    }
    /**
		Returns 50 - Failure to pay on civil or criminal offense with restriction CourtDispositionCodeType
	**/
    get Fifty(): ICourtDispositionCodeType {
        return this.FromId(23);
    }
    /**
		Returns 51 - Failure to pay on criminal offense CourtDispositionCodeType
	**/
    get FiftyOne(): ICourtDispositionCodeType {
        return this.FromId(24);
    }
    /**
		Returns 53 - Failure to comply CourtDispositionCodeType
	**/
    get FiftyThree(): ICourtDispositionCodeType {
        return this.FromId(25);
    }
    /**
		Returns COA - Court ordered action CourtDispositionCodeType
	**/
    get COA(): ICourtDispositionCodeType {
        return this.FromId(26);
    }
    /**
		Returns G - Guilty CourtDispositionCodeType
	**/
    get G(): ICourtDispositionCodeType {
        return this.FromId(27);
    }
    /**
		Returns 59M - MVD Error CourtDispositionCodeType
	**/
    get FiftyNineM(): ICourtDispositionCodeType {
        return this.FromId(28);
    }
    /**
		Returns 13 - Guilty CourtDispositionCodeType
	**/
    get Thirteen(): ICourtDispositionCodeType {
        return this.FromId(29);
    }
    /**
		Returns SAT - Court ordered action satisfied CourtDispositionCodeType
	**/
    get SAT(): ICourtDispositionCodeType {
        return this.FromId(30);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, dispositionCodeType: 4, value: '10', displayValue: '10 - Guilty', description: 'Plea of guilty or responsible; sentence suspended', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, dispositionCodeType: 4, value: '11', displayValue: '11 - Guilty', description: 'Plea of guilty or responsible; sentence imposed', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, dispositionCodeType: 4, value: '12', displayValue: '12 - Guilty', description: 'Bail or deposit given and declared forfeited', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, dispositionCodeType: 4, value: '20', displayValue: '20 - Guilty', description: 'Judgment of guilty or responsible; sentence suspended', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, dispositionCodeType: 4, value: '21', displayValue: '21 - Guilty', description: 'Judgment of guilty or responsible; sentence imposed', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, dispositionCodeType: 4, value: '22', displayValue: '22 - Guilty', description: 'Judgment of guilty or responsible; bail or deposit applied to fine/sanction', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, dispositionCodeType: 3, value: '30', displayValue: '30 - Dismissal', description: 'Judgment of acquittal (not guilty) or not responsible', sortOrder: 999999, active: true });
        this._dictionary.add('8', { id: 8, dispositionCodeType: 3, value: '43', displayValue: '43 - Dismissal', description: 'Dismissed on motion of court or defendant', sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, dispositionCodeType: 3, value: '44', displayValue: '44 - Dismissal', description: 'Dismissed on motion/request of prosecutor', sortOrder: 999999, active: true });
        this._dictionary.add('10', { id: 10, dispositionCodeType: 3, value: '45', displayValue: '45 - Dismissal', description: 'Dismissed on motion/request of arresting officer', sortOrder: 999999, active: true });
        this._dictionary.add('11', { id: 11, dispositionCodeType: 2, value: '54', displayValue: '54 - Failure to comply', description: 'Failure to comply; Nonresident Violator Compact', sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, dispositionCodeType: 6, value: '55', displayValue: '55 - Failure to pay on civil offense', description: 'Failure to pay on civil traffic offense; suspension of operating privilege ordered', sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, dispositionCodeType: 1, value: '56', displayValue: '56 - Failure to appear on criminal offense', description: 'Failure to appear on criminal offense; warrant of arrest issued; suspension of operating privilege ordered', sortOrder: 999999, active: true });
        this._dictionary.add('14', { id: 14, dispositionCodeType: 1, value: '57', displayValue: '57 - Failure to appear on criminal offense', description: 'Failure to appear on criminal offense; no warrant of arrest issued; suspension of operating privilege ordered', sortOrder: 999999, active: true });
        this._dictionary.add('15', { id: 15, dispositionCodeType: 1, value: '58', displayValue: '58 - Failure to appear on civil offense', description: 'Failure to appear on civil traffic offense; default judgment entered; suspension of operating privilege ordered', sortOrder: 999999, active: true });
        this._dictionary.add('16', { id: 16, dispositionCodeType: 5, value: '59', displayValue: '59 - Stay', description: 'Judgment/conviction set aside', sortOrder: 999999, active: true });
        this._dictionary.add('17', { id: 17, dispositionCodeType: 10, value: '60', displayValue: '60 - Criminal Failure to Appear satisfied', description: 'Criminal Failure to Appear satisfied', sortOrder: 999999, active: true });
        this._dictionary.add('18', { id: 18, dispositionCodeType: 9, value: '67', displayValue: '67 - Amended', description: 'Charge amended', sortOrder: 999999, active: true });
        this._dictionary.add('19', { id: 19, dispositionCodeType: 5, value: '70', displayValue: '70 - Appeal - hearing', description: 'Appeal', sortOrder: 999999, active: true });
        this._dictionary.add('20', { id: 20, dispositionCodeType: 8, value: '71', displayValue: '71 - Purge record', description: 'Purged record. Can only overlay disposition codes 55, 56, 57 & 58', sortOrder: 999999, active: true });
        this._dictionary.add('21', { id: 21, dispositionCodeType: 7, value: '76', displayValue: '76 - Set-aside pursuant to ARS 13-907', description: 'Set-aside pursuant to ARS 13-907', sortOrder: 999999, active: true });
        this._dictionary.add('22', { id: 22, dispositionCodeType: 9, value: '00', displayValue: '00 - Void', description: 'Court error or forced adjustment', sortOrder: 999999, active: true });
        this._dictionary.add('23', { id: 23, dispositionCodeType: 6, value: '50', displayValue: '50 - Failure to pay on civil or criminal offense with restriction', description: 'Failure to pay on civil/criminal traffic offense; restriction of operating privilege', sortOrder: 999999, active: true });
        this._dictionary.add('24', { id: 24, dispositionCodeType: 6, value: '51', displayValue: '51 - Failure to pay on criminal offense', description: 'Failure to pay on criminal offense; suspension of operating privilege ordered', sortOrder: 999999, active: true });
        this._dictionary.add('25', { id: 25, dispositionCodeType: 2, value: '53', displayValue: '53 - Failure to comply', description: 'Failure to comply; Nonresident Violator Compact', sortOrder: 999999, active: true });
        this._dictionary.add('26', { id: 26, dispositionCodeType: 11, value: 'COA', displayValue: 'COA - Court ordered action', description: 'Court ordered action', sortOrder: 999999, active: true });
        this._dictionary.add('27', { id: 27, dispositionCodeType: 4, value: 'G', displayValue: 'G - Guilty', description: 'Guilty', sortOrder: 999999, active: false });
        this._dictionary.add('28', { id: 28, dispositionCodeType: 9, value: '59M', displayValue: '59M - MVD Error', description: 'MVD Error', sortOrder: 999999, active: false });
        this._dictionary.add('29', { id: 29, dispositionCodeType: 4, value: '13', displayValue: '13 - Guilty', description: 'Plea of guilty or responsible', sortOrder: 999999, active: true });
        this._dictionary.add('30', { id: 30, dispositionCodeType: 12, value: 'SAT', displayValue: 'SAT - Court ordered action satisfied', description: 'Court ordered action satisfied', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ICourtDispositionCodeType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ICourtDispositionCodeType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ICourtDispositionCodeType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ICourtDispositionCodeType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ICourtDispositionCodeType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
